<div class="box-management">
  <div class="header-box">
    <div class="title-box">
      <i class="app-icon-timer"></i>
      HISTÓRICO
    </div>
    <div class="tag-status {{ status?.class }}">
      <i class="{{ status?.icon }}"></i>{{ status?.label }}
    </div>
  </div>

  <div class="history-content" [perfectScrollbar]="{ suppressScrollX: true }">
    <div class="timeline">
      <div class="timeline-item" *ngFor="let item of recentHistoryItems; let last = last" [class.last]="last">
        <div class="timeline-left">
          <div class="avatar-circle">
            <span class="initials">{{ getInitials(item) }}</span>
          </div>
          <div class="timeline-line"></div>
        </div>

        <div class="timeline-right">
          <div class="item-header">
            <span class="user-name" [ngClass]="{ 'is-you': isYou(item) }">
              {{ getFrom(item) }}
            </span>
            <!-- Badges for specific actions -->
            <span class="action-badge assumed" *ngIf="item.type === 'STARTED'">ASSUMIU</span>
            <span class="action-badge assumed" *ngIf="item.type === 'STARTED_PRICING'">ASSUMIU</span>
            <span class="action-badge abandoned" *ngIf="item.type === 'ABANDONED_PRICING'">ABANDONOU</span>
            <span class="action-badge finalized" *ngIf="item.type === 'CLOSED_EVAL'">FINALIZOU</span>
            <span class="action-badge sent" *ngIf="item.type === 'CLOSED_PRICING' || item.type === 'SENT_TO_EVAL'">ENVIOU</span>
            <span class="action-badge returned" *ngIf="item.type === 'RETURNED_TO_PRICING' || item.type === 'RETURNED_EVAL'">DEVOLVEU</span>
            <span class="action-badge sent" *ngIf="item.type === 'INTERVENTION_PRICE_ACCEPTED'">INTERVENÇÃO</span>
            <span class="action-badge edited-comment" *ngIf="item.type === 'EDITED_EVALUATION_COMMENT'">EDITOU</span>
          </div>

          <div class="secondary-text" [innerHTML]="getSecondaryText(item)"></div>

          <div class="comment-edit-diff" *ngIf="getEditedCommentDiff(item) as editDiff">
            <div class="comment-edit-block">
              <span class="comment-edit-label">Antes</span>
              <p class="comment-edit-text">{{ editDiff.previousText }}</p>
            </div>
            <div class="comment-edit-block comment-edit-block-new">
              <span class="comment-edit-label">Depois</span>
              <p class="comment-edit-text">{{ editDiff.newText }}</p>
            </div>
          </div>

          <div class="diff-container" *ngIf="getDurationText(item)">
            <span class="diff-label">{{ getDurationText(item) }}</span>
          </div>

          <ng-container *ngIf="getDiffItems(item) as diffItems">
            <div class="diff-container" *ngIf="diffItems.length > 0">
              <div class="diff-item" *ngFor="let diff of diffItems">
                <strong>{{ diff.fieldLabel }}</strong>: {{ diff.displayText }}
              </div>
            </div>
          </ng-container>

          <div class="comment-box" *ngIf="item.comments">
            <i class="material-icons">comment</i>
            <span class="commentary">{{ item.comments }}</span>
          </div>

          <div class="timestamp">
            {{ item.createdAt | date: "dd/MM/yyyy · HH:mm" }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-box" *ngIf="showMore && numHistoryItems > 0">
    <span class="view-all-link" (click)="onClickFullHistory()">
      VER TODOS ({{ numHistoryItems }})
    </span>
  </div>
</div>